import { Link, useLoaderData, useParams } from "react-router-dom";
import * as API from "../services/entrenamiento";

import { OpcionesEstadosTratamientos } from '../components/OpcionesEstadosTratamientos';

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getEntrenamientoByID(params.entrenamientoId);
}

export function EntrenamientoItem(props) {
  const entrenamiento = useLoaderData();
  const errorMessage = entrenamiento.message;

  const entrResp = entrenamiento.meta?.entrResp;
  const entrFecha = entrenamiento.meta?.metaFecha;
  const entrNumses = entrenamiento.meta?.entrNumses;
  const entrMedio = entrenamiento.meta?.entrMedio;
  console.log(entrMedio);
  const entrHipertenRad = entrenamiento.meta?.entrHipertenRad;
  const entrHiperlidRad = entrenamiento.meta?.entrHiperlidRad;
  const entrHiperglucRad = entrenamiento.meta?.entrHiperglucRad;
  const entrHistfamRad = entrenamiento.meta?.entrHistfamRad;
  const entrTabaqRad = entrenamiento.meta?.entrTabaqRad;
  const entrEstvidaRad = entrenamiento.meta?.entrEstvidaRad;
  const entrObesidRad = entrenamiento.meta?.entrObesidRad;
  const entrEnfermRad = entrenamiento.meta?.entrEnfermRad;
  const entrEnfermEsp = entrenamiento.meta?.entrEnfermEsp;
  const entrDolorpechoRad = entrenamiento.meta?.entrDolorpechoRad;
  const entrDolorpechoEsp = entrenamiento.meta?.entrDolorpechoEsp;
  const entrNoactpechoRad = entrenamiento.meta?.entrNoactpechoRad;
  const entrNoactpechoEsp = entrenamiento.meta?.entrNoactpechoEsp;
  const entrMareosRad = entrenamiento.meta?.entrMareosRad;
  const entrMareosEsp = entrenamiento.meta?.entrMareosEsp;
  const entrProbarticRad = entrenamiento.meta?.entrProbarticRad;
  const entrProbarticEsp = entrenamiento.meta?.entrProbarticEsp;
  const entrFarmcardRad = entrenamiento.meta?.entrFarmcardRad;
  const entrFarmcardEsp = entrenamiento.meta?.entrFarmcardEsp;
  const entrRaznoactRad = entrenamiento.meta?.entrRaznoactRad;
  const entrRaznoactEsp = entrenamiento.meta?.entrRaznoactEsp;
  const entrConcl = entrenamiento.meta?.entrConcl;
  const entrTrabactfis = entrenamiento.meta?.entrTrabactfis;
  const entrTrabactfisEsp = entrenamiento.meta?.entrTrabactfisEsp;
  const entrTiempocio = entrenamiento.meta?.entrTiempocio;
  const entrTiempocioEsp = entrenamiento.meta?.entrTiempocioEsp;
  const entrTipoejercsem = entrenamiento.meta?.entrTipoejercsem;
  const entrTipoejercmes = entrenamiento.meta?.entrTipoejercmes;
  const entrTipoejercano = entrenamiento.meta?.entrTipoejercano;
  const entrPercejerc = entrenamiento.meta?.entrPercejerc;
  const entrEjercnegRad = entrenamiento.meta?.entrEjercnegRad;
  const entrEjercnegEsp = entrenamiento.meta?.entrEjercnegEsp;
  const entrProgactfisRad = entrenamiento.meta?.entrProgactfisRad;
  const entrProgactfisEsp = entrenamiento.meta?.entrProgactfisEsp;
  const entrActmasgust = entrenamiento.meta?.entrActmasgust;
  const entrProgactfisconseg = entrenamiento.meta?.entrProgactfisconseg;
  const entrProgactfisdedic = entrenamiento.meta?.entrProgactfisdedic;
  const entrEjercultsem = entrenamiento.meta?.entrEjercultsem;
  const entrEjercvezsem = entrenamiento.meta?.entrEjercvezsem;
  const entrEjercpract = entrenamiento.meta?.entrEjercpract;
  const entrEjercintens = entrenamiento.meta?.entrEjercintens;
  const entrEjercpercep = entrenamiento.meta?.entrEjercpercep;
  const entrObs = entrenamiento.meta?.entrObs;
  const entrEstado = entrenamiento.meta?.entrEstado || 'seguimiento';

  const entrDate = new Date(entrenamiento.date);
  const diffDate = Math.abs(new Date() - entrDate) / 36e5;

  let { tratamientoId } = useParams();

  return (
    <>
      <div id='content'>
        {entrenamiento.length === 0 ? (
          <div>Cargando...</div>
        ) : errorMessage ? (
          <p>{errorMessage}</p>
        ) : (
          <form id='formUpdatelement'>
            <fieldset id='disabledContainer' disabled='disabled'>
              {entrNumses === 1 ? <h3>Datos visita</h3> : <></>}
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='entrResp'>Responsable</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='entrResp'
                      required
                      type='text'
                      readOnly
                      value={entrResp}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='entrFecha'>Fecha visita</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='entrFecha'
                      required
                      type='date'
                      readOnly
                      value={entrFecha}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='entrNumses'>Número de sesión</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='entrNumses'
                      required
                      disabled
                      type='number'
                      readOnly
                      value={entrNumses}
                    />
                  </div>
                </div>

                <div className='field'>
                  <label htmlFor='entrMedio'>Medio</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='entrMedio'
                        required
                        name='entrMedio'
                        value={entrMedio}
                        readOnly
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='presencial'>Presencial</option>
                        <option value='videoconferencia'>
                          Videoconferencia
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                {(props.userRole.includes('administrador')) && (
                <div className='field'>
                  <label htmlFor='entrEstado'>Estado de seguimiento</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='entrEstado'
                        readOnly
                        name='entrEstado'
                        value={entrEstado}
                      >
                        { OpcionesEstadosTratamientos.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                            disabled={option.disabled}
                          >
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                )}
              </div>

              {entrNumses === 1 ? (
                <>
                  <h3>Evaluación de factores de riesgo CV</h3>
                  <div className='grid--2col'>
                    <div
                      className='field key'
                      data-key={entrHipertenRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>Hipertensión</label>
                        <label className='radio' htmlFor='entrHipertenRadSi'>
                          <input
                            id='entrHipertenRadSi'
                            name='entrHipertenRad'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={entrHipertenRad === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrHipertenRadNo'>
                          <input
                            id='entrHipertenRadNo'
                            name='entrHipertenRad'
                            type='radio'
                            value='No'
                            readOnly
                            checked={entrHipertenRad === "No"}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrHiperlidRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>Hiperlipidemia</label>
                        <label className='radio' htmlFor='entrHiperlidRadSi'>
                          <input
                            id='entrHiperlidRadSi'
                            name='entrHiperlidRad'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={entrHiperlidRad === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrHiperlidRadNo'>
                          <input
                            id='entrHiperlidRadNo'
                            name='entrHiperlidRad'
                            type='radio'
                            value='No'
                            readOnly
                            checked={entrHiperlidRad === "No"}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrHiperglucRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>Hiperglucemia</label>
                        <label className='radio' htmlFor='entrHiperglucRadSi'>
                          <input
                            id='entrHiperglucRadSi'
                            name='entrHiperglucRad'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={entrHiperglucRad === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrHiperglucRadNo'>
                          <input
                            id='entrHiperglucRadNo'
                            name='entrHiperglucRad'
                            type='radio'
                            value='No'
                            readOnly
                            checked={entrHiperglucRad === "No"}
                          />
                          No
                        </label>
                      </div>
                    </div>

                    <div
                      className='field key'
                      data-key={entrHistfamRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          Historial familiar
                        </label>
                        <label className='radio' htmlFor='entrHistfamRadSi'>
                          <input
                            id='entrHistfamRadSi'
                            name='entrHistfamRad'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={entrHistfamRad === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrHistfamRadNo'>
                          <input
                            id='entrHistfamRadNo'
                            name='entrHistfamRad'
                            type='radio'
                            value='No'
                            readOnly
                            checked={entrHistfamRad === "No"}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrTabaqRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>Tabaquismo</label>
                        <label className='radio' htmlFor='entrTabaqRadSi'>
                          <input
                            id='entrTabaqRadSi'
                            name='entrTabaqRad'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={entrTabaqRad === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrTabaqRadNo'>
                          <input
                            id='entrTabaqRadNo'
                            name='entrTabaqRad'
                            type='radio'
                            value='No'
                            readOnly
                            checked={entrTabaqRad === "No"}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrEstvidaRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>Estilo vida</label>
                        <label className='radio' htmlFor='entrEstvidaRadSi'>
                          <input
                            id='entrEstvidaRadSi'
                            name='entrEstvidaRad'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={entrEstvidaRad === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrEstvidaRadNo'>
                          <input
                            id='entrEstvidaRadNo'
                            name='entrEstvidaRad'
                            type='radio'
                            value='No'
                            readOnly
                            checked={entrEstvidaRad === "No"}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrObesidRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>Obesidad</label>
                        <label className='radio' htmlFor='entrObesidRadSi'>
                          <input
                            id='entrObesidRadSi'
                            name='entrObesidRad'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={entrObesidRad === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrObesidRadNo'>
                          <input
                            id='entrObesidRadNo'
                            name='entrObesidRad'
                            type='radio'
                            value='No'
                            readOnly
                            checked={entrObesidRad === "No"}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrEnfermRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Le ha dicho el médico alguna vez que padece una
                          enfermedad y que solo debe hacer actividad física que
                          le aconseje un médico?
                        </label>
                        <label className='radio' htmlFor='entrEnfermRadSi'>
                          <input
                            id='entrEnfermRadSi'
                            name='entrEnfermRad'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={entrEnfermRad === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrEnfermRadNo'>
                          <input
                            id='entrEnfermRadNo'
                            name='entrEnfermRad'
                            type='radio'
                            value='No'
                            readOnly
                            checked={entrEnfermRad === "No"}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='entrEnfermEsp'>
                        Enfermedad - Especificar
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrEnfermEsp'
                          type='text'
                          readOnly
                          value={entrEnfermEsp}
                        />
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrDolorpechoRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Tiene dolor o molestias en el pecho cuando hace
                          actividad física?
                        </label>
                        <label className='radio' htmlFor='entrDolorpechoRadSi'>
                          <input
                            id='entrDolorpechoRadSi'
                            name='entrDolorpechoRad'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={entrDolorpechoRad === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrDolorpechoRadNo'>
                          <input
                            id='entrDolorpechoRadNo'
                            name='entrDolorpechoRad'
                            type='radio'
                            value='No'
                            readOnly
                            checked={entrDolorpechoRad === "No"}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='entrDolorpechoEsp'>
                        Molestias - Especificar
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrDolorpechoEsp'
                          type='text'
                          readOnly
                          value={entrDolorpechoEsp}
                        />
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrNoactpechoRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          En el último mes ¿ha tenido dolor en el pecho cuando
                          no hacía actividad física?
                        </label>
                        <label className='radio' htmlFor='entrNoactpechoRadSi'>
                          <input
                            id='entrNoactpechoRadSi'
                            name='entrNoactpechoRad'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={entrNoactpechoRad === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrNoactpechoRadNo'>
                          <input
                            id='entrNoactpechoRadNo'
                            name='entrNoactpechoRad'
                            type='radio'
                            value='No'
                            readOnly
                            checked={entrNoactpechoRad === "No"}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='entrNoactpechoEsp'>
                        Dolor en el pecho - Especificar
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrNoactpechoEsp'
                          type='text'
                          readOnly
                          value={entrNoactpechoEsp}
                        />
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrMareosRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Pierde el equilibrio debido a mareos o se ha
                          desmayado alguna vez?
                        </label>
                        <label className='radio' htmlFor='entrMareosRadSi'>
                          <input
                            id='entrMareosRadSi'
                            name='entrMareosRad'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={entrMareosRad === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrMareosRadNo'>
                          <input
                            id='entrMareosRadNo'
                            name='entrMareosRad'
                            type='radio'
                            value='No'
                            readOnly
                            checked={entrMareosRad === "No"}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='entrMareosEsp'>
                        Equilibrio - Especificar
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrMareosEsp'
                          type='text'
                          readOnly
                          value={entrMareosEsp}
                        />
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrProbarticRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Tiene problema de huesos o articulaciones (espalda,
                          rodillas o cadera) que puedan empeorar si aumenta la
                          actividad física?
                        </label>
                        <label className='radio' htmlFor='entrProbarticRadSi'>
                          <input
                            id='entrProbarticRadSi'
                            name='entrProbarticRad'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={entrProbarticRad === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrProbarticRadNo'>
                          <input
                            id='entrProbarticRadNo'
                            name='entrProbarticRad'
                            type='radio'
                            value='No'
                            readOnly
                            checked={entrProbarticRad === "No"}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='entrProbarticEsp'>
                        Articulaciones - Especificar
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrProbarticEsp'
                          type='text'
                          readOnly
                          value={entrProbarticEsp}
                        />
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrFarmcardRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Le receta su médico algún fármaco para la tensión
                          arterial o problema cardiaco?
                        </label>
                        <label className='radio' htmlFor='entrFarmcardRadSi'>
                          <input
                            id='entrFarmcardRadSi'
                            name='entrFarmcardRad'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={entrFarmcardRad === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrFarmcardRadNo'>
                          <input
                            id='entrFarmcardRadNo'
                            name='entrFarmcardRad'
                            type='radio'
                            value='No'
                            readOnly
                            checked={entrFarmcardRad === "No"}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='entrFarmcardEsp'>
                        Especificar Fármaco
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrFarmcardEsp'
                          type='text'
                          readOnly
                          value={entrFarmcardEsp}
                        />
                      </div>
                    </div>
                    <div
                      className='field key'
                      data-key={entrRaznoactRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Conoce alguna razón por la que no podría hacer
                          actividad física?
                        </label>
                        <label className='radio' htmlFor='entrRaznoactRadSi'>
                          <input
                            id='entrRaznoactRadSi'
                            name='entrRaznoactRad'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={entrRaznoactRad === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrRaznoactRadNo'>
                          <input
                            id='entrRaznoactRadNo'
                            name='entrRaznoactRad'
                            type='radio'
                            value='No'
                            readOnly
                            checked={entrRaznoactRad === "No"}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='entrRaznoactEsp'>
                        Razón - Especificar
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrRaznoactEsp'
                          type='text'
                          readOnly
                          value={entrRaznoactEsp}
                        />
                      </div>
                    </div>

                    <div className='field'>
                      <label htmlFor='entrConcl'>Conclusiones</label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='entrConcl'
                            required
                            name='entrConcl'
                            value={entrConcl}
                            readOnly
                          >
                            <option disabled value=''>
                              -- Selecciona una opción --
                            </option>
                            <option value='si-espec'>
                              Sí debería realizar un chequeo con un especialista
                            </option>
                            <option value='no-espec'>
                              No es necesario chequeo con un especialista
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <h3>Realización de actividad física</h3>
                  <div className='grid--2col'>
                    <div className='field'>
                      <label htmlFor='entrTrabactfis'>
                        En el trabajo - ¿Realiza una actividad física?
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='entrTrabactfis'
                            required
                            name='entrTrabactfis'
                            value={entrTrabactfis}
                            readOnly
                          >
                            <option disabled value=''>
                              -- Selecciona una opción --
                            </option>
                            <option value='intens'>Intensa</option>
                            <option value='moder'>Moderada</option>
                            <option value='sedent'>Sedentaria</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='entrTrabactfisEsp'>
                        En el trabajo - ¿Desde cuándo realiza dicha actividad?
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrTrabactfisEsp'
                          type='text'
                          required
                          readOnly
                          value={entrTrabactfisEsp}
                        />
                      </div>
                    </div>

                    <div className='field'>
                      <label htmlFor='entrTiempocio'>
                        ¿En su tiempo de ocio ha realizado o realiza ejercicio?
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='entrTiempocio'
                            required
                            name='entrTiempocio'
                            value={entrTiempocio}
                            readOnly
                          >
                            <option disabled value=''>
                              -- Selecciona una opción --
                            </option>
                            <option value='pasad'>Sí, en el pasado</option>
                            <option value='si-actual'>Sí, actualmente</option>
                            <option value='si-pasad-actual'>
                              Sí, en el pasado y actualmente
                            </option>
                            <option value='no'>No</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='entrTiempocioEsp'>
                        Especificar frecuencia ejercicio
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrTiempocioEsp'
                          type='text'
                          required
                          readOnly
                          value={entrTiempocioEsp}
                        />
                      </div>
                    </div>

                    <div className='field'>
                      <label htmlFor='entrTipoejercsem'>
                        Tipo(s) de ejercicio habitual en la última semana
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrTipoejercsem'
                          type='text'
                          required
                          readOnly
                          value={entrTipoejercsem}
                        />
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='entrTipoejercmes'>
                        Tipo(s) de ejercicio habitual en el último mes
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrTipoejercmes'
                          type='text'
                          required
                          readOnly
                          value={entrTipoejercmes}
                        />
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='entrTipoejercano'>
                        Tipo(s) de ejercicio habitual en el último año
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrTipoejercano'
                          type='text'
                          required
                          readOnly
                          value={entrTipoejercano}
                        />
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='entrPercejerc'>
                        Percepción del ejercicio
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='entrPercejerc'
                            required
                            name='entrPercejerc'
                            value={entrPercejerc}
                            readOnly
                          >
                            <option disabled value=''>
                              -- Selecciona una opción --
                            </option>
                            <option value='cansa'>Cansa</option>
                            <option value='tensa'>Tensa</option>
                            <option value='relaja'>Relaja</option>
                            <option value='tonifica'>Tonifica</option>
                            <option value='sienta-bien'>Sienta bien</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='grid--2col'>
                    <div
                      className='field key'
                      data-key={entrEjercnegRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Tiene o ha tenido alguna sensación negativa hacia el
                          ejercicio?
                        </label>
                        <label className='radio' htmlFor='entrEjercnegRadSi'>
                          <input
                            id='entrEjercnegRadSi'
                            name='entrEjercnegRad'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={entrEjercnegRad === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrEjercnegRadNo'>
                          <input
                            id='entrEjercnegRadNo'
                            name='entrEjercnegRad'
                            type='radio'
                            value='No'
                            readOnly
                            checked={entrEjercnegRad === "No"}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='entrEjercnegEsp'>
                        Sensación Negativa - Especificar
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrEjercnegEsp'
                          type='text'
                          readOnly
                          value={entrEjercnegEsp}
                        />
                      </div>
                    </div>

                    <div
                      className='field key'
                      data-key={entrProgactfisRad?.toString()}
                    >
                      <div className='control'>
                        <label className='radio-title'>
                          ¿Le cuesta ser constante en programas de actividad
                          física?
                        </label>
                        <label className='radio' htmlFor='entrProgactfisRadSi'>
                          <input
                            id='entrProgactfisRadSi'
                            name='entrProgactfisRad'
                            type='radio'
                            value='Si'
                            readOnly
                            checked={entrProgactfisRad === "Si"}
                          />
                          Si
                        </label>
                        <label className='radio' htmlFor='entrProgactfisRadNo'>
                          <input
                            id='entrProgactfisRadNo'
                            name='entrProgactfisRad'
                            type='radio'
                            value='No'
                            readOnly
                            checked={entrProgactfisRad === "No"}
                          />
                          No
                        </label>
                      </div>
                    </div>
                    <div className='field lock'>
                      <label htmlFor='entrProgactfisEsp'>
                        Constante - Especificar
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrProgactfisEsp'
                          type='text'
                          readOnly
                          value={entrProgactfisEsp}
                        />
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='entrActmasgust'>
                        ¿Qué tipo de actividades físicas le gusta más realizar?
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrActmasgust'
                          type='text'
                          required
                          readOnly
                          value={entrActmasgust}
                        />
                      </div>
                    </div>

                    <div className='field'>
                      <label htmlFor='entrProgactfisconseg'>
                        ¿Qué te gustaría conseguir con un programa de actividad
                        física?
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrProgactfisconseg'
                          type='text'
                          required
                          readOnly
                          value={entrProgactfisconseg}
                        />
                      </div>
                    </div>
                    <div className='field'>
                      <label htmlFor='entrProgactfisdedic'>
                        ¿Qué dedicación podría dedicarle al programa de
                        actividad física?
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='entrProgactfisdedic'
                          type='text'
                          required
                          readOnly
                          value={entrProgactfisdedic}
                        />
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                // Here start 'Sesiones Seguimiento'

                <div className='grid--2col'>
                  <div className='field'>
                    <label htmlFor='entrEjercultsem'>
                      ¿Cuántas veces has hecho ejercicio en la última semana?
                    </label>
                    <div className='control'>
                      <div className='select'>
                        <select
                          className='select'
                          id='entrEjercultsem'
                          required
                          name='entrEjercultsem'
                          value={entrEjercultsem}
                          readOnly
                        >
                          <option disabled value=''>
                            -- Selecciona una opción --
                          </option>
                          <option value='nada'>Nada</option>
                          <option value='una-dos'>1-2 veces</option>
                          <option value='tres-cuatro'>3-4 veces</option>
                          <option value='cinco-siete'>5-7 veces</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className='field'>
                    <label htmlFor='entrEjercvezsem'>
                      ¿Cuánto tiempo has hecho ejercicio cada vez por semana?
                    </label>
                    <div className='control'>
                      <div className='select'>
                        <select
                          className='select'
                          id='entrEjercvezsem'
                          required
                          name='entrEjercvezsem'
                          value={entrEjercvezsem}
                          readOnly
                        >
                          <option disabled value=''>
                            -- Selecciona una opción --
                          </option>
                          <option value='nada'>Nada</option>
                          <option value='menos-una-h'>Menos de 1 hora</option>
                          <option value='una-h'>1 hora</option>
                          <option value='mas-una-h'>Más de 1 hora</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className='field'>
                    <label htmlFor='entrEjercpract'>
                      ¿Qué deporte o ejercicio has practicado?
                    </label>
                    <div className='control'>
                      <input
                        className='input'
                        id='entrEjercpract'
                        required
                        type='text'
                        value={entrEjercpract}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className='field'>
                    <label htmlFor='entrEjercintens'>
                      Percepción del grado de intensidad del ejercicio
                    </label>
                    <div className='control'>
                      <div className='select'>
                        <select
                          className='select'
                          id='entrEjercintens'
                          required
                          name='entrEjercintens'
                          value={entrEjercintens}
                          readOnly
                        >
                          <option disabled value=''>
                            -- Selecciona una opción --
                          </option>
                          <option value='uno'>1 - Poco o nada intenso</option>
                          <option value='dos'>2</option>
                          <option value='tres'>3</option>
                          <option value='cuatro'>4</option>
                          <option value='cinco'>5 - Tolerable</option>
                          <option value='seis'>6</option>
                          <option value='siete'>7</option>
                          <option value='ocho'>8</option>
                          <option value='nueve'>9</option>
                          <option value='diez'>10 - Extenuante</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className='field'>
                    <label htmlFor='entrEjercpercep'>
                      Percepción del ejercicio
                    </label>
                    <div className='control'>
                      <div className='select'>
                        <select
                          className='select'
                          id='entrEjercpercep'
                          required
                          name='entrEjercpercep'
                          value={entrEjercpercep}
                          readOnly
                        >
                          <option disabled value=''>
                            -- Selecciona una opción --
                          </option>
                          <option value='cansa'>Cansa</option>
                          <option value='tensa'>Tensa</option>
                          <option value='relaja'>Relaja</option>
                          <option value='tonifica'>Tonifica</option>
                          <option value='sienta-bien'>Sienta bien</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className='field'>
                <label className='' htmlFor='entrObs'>
                  Observaciones
                </label>
                <div className='control'>
                  <textarea
                    className='textarea'
                    name='entrObs'
                    id='entrObs'
                    readOnly
                    value={entrObs}
                  ></textarea>
                </div>
              </div>
            </fieldset>
          </form>
        )}
      </div>
      {!errorMessage && (
        <div id='actions'>
          {((diffDate <= 72 && props.userRole.includes('entrenamiento')) || props.userRole.includes('administrador')) && (
            <Link className='button is-link' to={`edit`}>
              Editar
            </Link>
          )}
          {(props.userRole.includes('administrador') || props.userRole.includes('entrenamiento')) && (
            <Link
              className='button is-link'
              to={`../${tratamientoId}/seguimiento/entrenamiento/new`}
            >
              Nuevo
            </Link>
          )}
        </div>
      )}
    </>
  );
}
